export class ImportacionPlantillaModel {
    importacionId: number;
    nombre: string;
    primeraFila?: number;
    columnaClave?: number;
    tipoImportacion?: number;
    hojas?: number;
    camposImportacion: any; 
}
